import { db } from 'src/config/firebase';

const getTeam = async (companyId) => {
  try {
    const snapshot = await db
      .ref('PartnerTeams')
      .orderByChild('companyId')
      .equalTo(companyId)
      .once('value');
    const teamData = await snapshot.val();
    const array = [{ label: 'my self', id: 'myself' }];

    if (teamData) {
      for (var i in teamData) {
        if (teamData[i].enabled) {
          array.push({
            label: `${teamData[i].firstName} ${teamData[i].lastName}`,
            id: teamData[i].id,
          });
        }
      }
    }

    return array;
  } catch (error) {
    console.warn('Error fetching team: ', error.message);
  }
};

export const getTeamById = async (teamId, tableName) => {
  try {
    const snapshot = await db
      .ref(`${tableName}/${teamId}`)
      .once('value');
    const teamData = await snapshot.val();

    return teamData;
  } catch (error) {
    console.warn('Error fetching team by ID: ', error.message);
  }
}

export default getTeam;
